import React, { useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import { settings } from "../../utils/slick/settings";
import shareIcon from "../../assets/icons/art_work.svg";
import ArrowIcon from "../../assets/icons/svgs/arrow_left.svg";
import ArticleCard from "../../components/Articles/common/ArticleCardV2";
import * as styles from "./ArticlesCarousel.module.scss";

const COLORS_MOCK = ["green", "blue", "orange"];
const ICONS_MOCK = [shareIcon];

const ArticlesCarousel = ({ data }) => {
  const sliderRef = useRef(null);
  const [currentStep, setCurrentStep] = useState(0);

  const gotoNext = () => {
    sliderRef.current.slickNext();
  };

  const gotoPrev = () => {
    sliderRef.current.slickPrev();
  };

  const beforeChange = (_, next) => {
    setCurrentStep(next);
  };

  const stepsCount = useMemo(() => data.guideNodeMain.articleGroups.length, [data.guideNodeMain.articleGroups]);

  const slickSettings = { ...settings, beforeChange };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.texts}>
          <h3>Vores artikler</h3>
          <p>Få det bedste ud af holdingselskabet</p>
        </div>
        <div className={styles.controlls}>
          <button type="button" onClick={gotoPrev}>
            <ArrowIcon />
          </button>
          <button type="button" onClick={gotoNext}>
            <ArrowIcon />
          </button>
        </div>
      </div>
      <div className={styles.slider}>
        <Slider {...slickSettings} ref={sliderRef}>
          {data &&
            data.guideNodeMain.articleGroups.map((articleGroup, index) => (
              <ArticleCard
                {...articleGroup}
                key={articleGroup.id}
                color={COLORS_MOCK[index % 3]}
                icon={ICONS_MOCK[0]}
              />
            ))}
        </Slider>
        <div className={styles.progress}>
          <div
            className={styles.progressVal}
            style={{ left: `calc(264px / ${stepsCount} * ${currentStep})`, width: `calc(264px / ${stepsCount})` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ArticlesCarousel;
